import React, { Component } from 'react';
import { map, get, reduce, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import { Modal } from 'antd';
import PubSub from '../src/services/PubSub';
import QueryGroups from '../src/components/graphql/getABMGroups';
import SEND_USER_PROFILES from '../src/components/graphql/sendUserProfiles';
import {
    Button,
    Drawer,
    HasPermissions,
    Loading,
    Row,
    Text,
    IconContainer,
    Icon,
    If,
    NotFound,
    Container,
    Main,
    FlexContainer
} from '../src/components/common';
import ProfileCard from '../src/components/sections/Profiles/ProfileCard';
import CreateProfileForm from '../src/components/sections/Profiles/CreateProfileForm';
import EditProfileForm from '../src/components/sections/Profiles/EditProfileForm';
import { _get } from '../src/utils/misc';

class Profiles extends Component {
    state = {
        currentSelected: [],
        currentResourceSelected: 'generic',
        activeProduct: null,
        pageSize: 50,
        currentPage: 1,
        loading: false,
        editMode: false,
        drawerVisible: false,
        visible: false,
        iconName: null,
        textInfo: null
    };

    componentDidMount() {
        PubSub.dispatch('SET_RIGHT_HEADER', () => this.rightHeader());
    }

    componentWillUnmount() {
        PubSub.dispatch('SET_RIGHT_HEADER', () => '');
    }

    toggleEditMode = (item) => {
        this.setState({
            editMode: true,
            drawerVisible: !this.state.drawerVisible,
            currentSelected: item
        });
    };

    toggleCreateMode = () => {
        this.setState({
            editMode: false,
            drawerVisible: !this.state.drawerVisible
        });
    };

    _toggleModal = (iconName, textInfo) =>
        this.setState(({ visible }) => ({
            visible: !visible,
            iconName,
            textInfo
        }));

    onSubmitSuccess = () => this.toggleCreateMode();

    modalInfo = () => {
        const { visible, iconName, textInfo } = this.state;

        return (
            <Modal
                closable={false}
                title={null}
                visible={visible}
                footer={null}
            >
                <FlexContainer margin={30} align='center' direction='column'>
                    <IconContainer color='#f38630'>
                        <Icon name={iconName} color='#ffffff' size={46.8} />
                    </IconContainer>
                    <FlexContainer mY={30} direction='column' align='center'>
                        <Row justify='center'>
                            <Text text={textInfo} />
                        </Row>
                    </FlexContainer>
                    <FlexContainer justify='flex-end' style={{ width: '100%' }}>
                        <Button
                            text='Cerrar'
                            style={{ width: '100px' }}
                            onClick={this._toggleModal}
                        />
                    </FlexContainer>
                </FlexContainer>
            </Modal>
        );
    };

    handleExport = async () => {
        try {
            const { client, session } = this.props;
            const email = get(session, 'email');
            const {
                data: {
                    sendUserProfiles: { internalCode }
                }
            } = await client.mutate({
                mutation: SEND_USER_PROFILES,
                variables: {
                    email
                }
            });

            internalCode === '200'
                ? this._toggleModal(
                      'check',
                      `Correo enviado con exito a ${email}`
                  )
                : this._toggleModal('trash', 'Ha ocurrido un error!');
        } catch (e) {
            console.log('Error >>', e);
            this._toggleModal('trash', 'Ha ocurrido un error!');
        }
    };

    rightHeader = () => (
        <>
            {/* <HasPermissions to={['profiles-page:export']}> */}
            <Button text='Exportar' secondary onClick={this.handleExport} />
            {/* </HasPermissions> */}
            <HasPermissions to={['profiles-page:create']}>
                <Button
                    text='Crear Perfil'
                    style={{ whiteSpace: 'nowrap', marginLeft: '15px' }}
                    onClick={this.toggleCreateMode}
                />
            </HasPermissions>
        </>
    );

    _getInitialValuesFrom(item) {
        const { session } = this.props;
        const permissions = reduce(
            get(item, 'permissions'),
            (acc, { name, accesses }) => {
                return Object.assign(acc, { [name]: accesses });
            },
            {}
        );
        return {
            id: get(item, 'id'),
            groupName: get(item, 'alias', ''),
            groupDescription: get(item, 'description', ''),
            createdIn: get(item, 'createdIn', ''),
            updatedIn: get(item, 'updatedIn', ''),
            createdBy: _get(item, 'createdBy', get(session, 'email')),
            ...permissions
            // ...item
        };
    }

    _onModalClose = (editMode) => {
        console.log('ok');
        this.setState({ drawerVisible: false, editMode: editMode || false });
    };

    render() {
        const { editMode, drawerVisible, currentSelected } = this.state;
        return (
            <HasPermissions
                to={['profiles-page:view']}
                otherwise={
                    <NotFound
                        firstTextLine='Página no encontrada'
                        style={{ minHeight: '90vh' }}
                    />
                }
            >
                <QueryGroups fetchPolicy='network-only'>
                    {({ data, loading }) => {
                        return (
                            <Container>
                                <Main
                                    style={{
                                        minHeight: 280,
                                        height: '100%',
                                        background: '#f4f4f4'
                                    }}
                                    withFooter
                                >
                                    <Loading loading={loading}>
                                        <FlexContainer
                                            shrink={0}
                                            grow={1}
                                            direction='column'
                                        >
                                            <FlexContainer wrap>
                                                {map(
                                                    orderBy(
                                                        data,
                                                        ['alias'],
                                                        'asc'
                                                    ),
                                                    (item, index) => (
                                                        <ProfileCard
                                                            item={item}
                                                            onEdit={
                                                                this
                                                                    .toggleEditMode
                                                            }
                                                        />
                                                    )
                                                )}
                                            </FlexContainer>
                                        </FlexContainer>
                                        <Drawer
                                            width='50%'
                                            closable
                                            title={`${
                                                editMode ? 'Editar' : 'Crear'
                                            } Perfil`}
                                            visible={drawerVisible}
                                            onClose={() =>
                                                this._onModalClose(editMode)
                                            }
                                        >
                                            <If
                                                condition={editMode}
                                                then={
                                                    <EditProfileForm
                                                        editMode
                                                        initialValues={this._getInitialValuesFrom(
                                                            currentSelected
                                                        )}
                                                        render={this.renderForm}
                                                        onSubmitSuccess={() =>
                                                            this.setState({
                                                                editMode: false,
                                                                drawerVisible: false,
                                                                currentSelected: null
                                                            })
                                                        }
                                                        onReset={
                                                            this.toggleEditMode
                                                        }
                                                        enableReinitialize
                                                    />
                                                }
                                                else={
                                                    <CreateProfileForm
                                                        initialValues={this._getInitialValuesFrom(
                                                            {}
                                                        )}
                                                        onSubmitSuccess={
                                                            this.onSubmitSuccess
                                                        }
                                                        onReset={
                                                            this.toggleEditMode
                                                        }
                                                        render={this.renderForm}
                                                        enableReinitialize
                                                    />
                                                }
                                            />
                                        </Drawer>
                                    </Loading>
                                </Main>
                            </Container>
                        );
                    }}
                </QueryGroups>
                {this.modalInfo()}
            </HasPermissions>
        );
    }
}

Profiles.propTypes = {
    session: PropTypes.object,
    client: PropTypes.object
};

export default withApollo(Profiles);
